import { useCallback } from 'react';

import { type PublicBoard } from '@air/api/types';

import { usePublicPermissions } from '~/components/PublicPermissionsProvider';
import { type GetItemMenuOptionsCallback } from '~/constants/MenuOptions';
import { useGetPublicCustomFieldsMenuOptions } from '~/hooks/useGetCustomFieldsMenuOptions';
import { useGetPublicBoardMenuOptions } from '~/hooks/useGetPublicBoardMenuOptions';
import { canChangeBoardCustomFields } from '~/utils/permissions/boardPermissions';

export function useGetPublicBoardMenuOptionsCallback() {
  const { permissions } = usePublicPermissions();
  const { getCustomFieldsMenuOptions } = useGetPublicCustomFieldsMenuOptions();

  const { getBoardMenuOptions } = useGetPublicBoardMenuOptions();

  const getBoardMenuOptionsCallback: GetItemMenuOptionsCallback<PublicBoard> = useCallback(
    ({ item: board }) =>
      () => {
        const canEditCustomFields = canChangeBoardCustomFields(permissions);

        return getBoardMenuOptions({
          customFieldsMenuOptions: canEditCustomFields ? getCustomFieldsMenuOptions({ boards: [board] }) : undefined,
        });
      },
    [permissions, getBoardMenuOptions, getCustomFieldsMenuOptions],
  );

  return {
    getBoardMenuOptionsCallback,
  };
}
